<template>
  <div class="ReciveCard">
    <div class="back-img">
      <van-image :src="require('@/assets/images/temp/recive-1.png')"></van-image>
    </div>
    <div class="form form-100" v-if="step===1">
      <div class="card-img">
        <van-image :src="require('@/assets/images/temp/recive-2.png')"></van-image>
        <div class="card-text">
          <div class="left">
            <span class="small">￥</span>
            <span class="big">{{cardData.cardMoney|priceFilter}}</span>
          </div>
          <div class="right">{{cardData.cardName}}</div>
        </div>
      </div>
      <van-button class="submit" @click="getRecive">领取</van-button>
    </div>
    <div class="form" v-if="step===2">
      <van-cell-group class="no-border no-back">
        <van-field placeholder="请输入手机号" type="text" v-model="form.phone"></van-field>
      </van-cell-group>
      <van-cell-group class="no-border no-back flex-button">
        <van-field placeholder="请输入验证码" type="text" v-model="form.captcha"></van-field>
        <van-button
          class="btn-code"
          type="primary"
          color="#6495FE"
          @click="getCatcha"
          :disabled="downTime>0"
        >{{btnCodeText}}</van-button>
      </van-cell-group>
      <van-button class="submit" @click="getSubmit">确认</van-button>
    </div>
  </div>
</template>
<script>
import { mPattern } from "@/assets/js/rules";
export default {
  name: "ReciveCard",
  data () {
    return {
      form: {
        phone: "",
        captcha: ""
      },
      step: 1, // 1为领券2为提交表单
      downTime: 0,
      cardData: {}
    };
  },
  computed: {
    btnCodeText () {
      return this.downTime > 0 ? this.downTime + "s后重新获取" : "获取验证码";
    }
  },
  mounted () {
    this.initData();
  },
  methods: {
    // 定时器
    countDown (that) {
      if (this.downTime === 0) {
      } else {
        this.downTime--;
        // 循环调用
        setTimeout(function () {
          that.countDown(that);
        }, 1000);
      }
    },
    // 获取验证码
    getCatcha () {
      if (!this.form.phone) {
        this.$error("请输入手机号");
      } else if (!mPattern.test(this.form.phone)) {
        this.$error("手机号码格式有误");
      } else {
        this.downTime = 60;
        let that = this;
        that.countDown(that);
      }
    },
    // 验证码表单
    testParam (param) {
      if (!param.phone) {
        this.$error("请输入手机号");
        return false;
      } else if (!mPattern.test(param.phone)) {
        this.$error("手机号格式有误");
        return false;
      } else if (!param.captcha) {
        this.$error("请输入验证码");
        return false;
      } else {
        return true;
      }
    },
    // 提交表单
    getSubmit () {
      if (this.testParam(this.form)) {
        console.log("success");
        this.go("/reciveSuccess");
      }
    },
    async initData () {
      try {
        this.$loading("加载中");
        let res = await this.request("/user/userCard/get", {
          id: this.$route.query.id
        });
        this.$loadingClose();
        this.cardData = res.data;
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    },
    // 领取
    async getRecive () {
      try {
        // this.step = 2;
        let res = await this.request("/user/userCard/accept", {
          id: this.$route.query.id,
          cardNewUserCardId: this.$route.query.cardNewUserCardId
        });
        if (res.code === 0) {
          this.$error("领取成功");
          setTimeout(() => {
            this.go("/ReciveSuccess");
          }, 1500);
        } else {
          this.$error(res.msg);
        }
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
@long: 75%;
.size {
  height: 40px;
  line-height: 40px;
}
.ReciveCard {
  .wh(100%, 100vh);
  overflow: hidden;
  position: relative;
}
.back-img {
  position: absolute;
  .wh(100%, 100vh);
  overflow: hidden;
  .van-image {
    .wh(100%, 100vh);
  }
}
.form {
  position: absolute;
  width: @long;
  top: 50%;
  left: 50%;
  transform: translateX(-50%);
  .van-cell {
    background: #ffe06a;
    border-radius: 5px;
    .size();
    padding: 0 15px;
    /deep/input::-webkit-input-placeholder {
      color: #b49006;
    }
    /deep/input::-moz-input-placeholder {
      color: #b49006;
    }
    /deep/input::-ms-input-placeholder {
      color: #b49006;
    }
  }
  .btn-code {
    background: #ffa83e !important;
    font-size: 12px;
    border: 0;
    padding: 0;
    .size();
  }
  .submit {
    border-radius: 20px;
    width: @long;
    margin: 15px auto;
    .size();
    display: block;
    color: #fff;
    border: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 173, 62, 1) 0%,
      rgba(255, 140, 62, 1) 100%
    );
    box-shadow: 0px 0px 4px 0px rgba(255, 180, 106, 1),
      0px 2px 4px 0px rgba(255, 159, 94, 1);
  }
  .card-img {
    position: relative;
    margin-bottom: 30px;
    .van-image {
      width: 100%;
    }
    .card-text {
      position: absolute;
      top: 50%;
      width: 90%;
      transform: translateY(-50%);
      padding: 0 10px;
      .fj();
      align-items: center;
      .left {
        color: #ff6700;
        .small {
          font-size: 14px;
        }
        .big {
          font-size: 22px;
        }
      }
      .right {
        .sc(16px, #ff6700);
      }
    }
  }
}
.form-100 {
  width: 80%;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border: 0;
}
.van-cell-group {
  background: transparent;
  margin-bottom: 20px;
}
.flex-button {
  .flex-center();
  justify-content: space-between;
  .van-cell {
    width: 60%;
  }
  .btn-code {
    width: 35%;
  }
}
</style>